function factory({ window, document, thn }) {

  const engine = {};

  engine.languageCheck = function languageCheck(ctx) {

    return new Promise(function (resolve, reject) {

      thn.domReady().then(function () {

        const lang = window.location.search.match(/lang=(\w{2})/);
        const aux = lang && lang.length > 1 && lang[1];
        if (aux && ctx.langs.test(aux)) {
          resolve(aux);
          return;
        }

        resolve('es');
      });
    });
  };

  return engine;

}

export { factory };
